import {
  getObject,
  getList,
  getInt32,
} from "@surya-digital/leo-ts-types";
import { GridOptionV1, GridOptionV1DTO } from "../types/gridOptionV1";
import { GridSingleSelectResultV1, GridSingleSelectResultV1DTO } from "./gridSingleSelectResultV1";

export interface GridSingleSelectRowResultV1DTO {
  gridOptionV1: GridOptionV1DTO;
  singleSelectResults: GridSingleSelectResultV1DTO[];
  totalResponses: number;
}

export class GridSingleSelectRowResultV1 {
  readonly isGridSingleSelectRowResultV1GridSingleSelectRowResultV1: boolean = true;

  readonly gridOptionV1: GridOptionV1;
  readonly singleSelectResults: GridSingleSelectResultV1[];
  readonly totalResponses: number;

  static readonly constraints = {
    "singleSelectResults": {
      "maxSize": 32,
    },
  }

  constructor(
  gridOptionV1: GridOptionV1, 
  singleSelectResults: GridSingleSelectResultV1[], 
  totalResponses: number
  ) {
    this.gridOptionV1 = gridOptionV1;
    GridSingleSelectRowResultV1.validateSingleSelectResults(singleSelectResults);
    this.singleSelectResults = singleSelectResults;
    this.totalResponses = totalResponses;
  }

  static fromDTO(dto: GridSingleSelectRowResultV1DTO): GridSingleSelectRowResultV1 {
    const gridOptionV1 = GridOptionV1.fromDTO(getObject(dto, "gridOptionV1", InvalidGridSingleSelectRowResultV1GridOptionV1Error));
    const singleSelectResults = getList<GridSingleSelectResultV1DTO, GridSingleSelectResultV1>(
      dto,
      "singleSelectResults",
      GridSingleSelectResultV1.fromDTO,
      InvalidGridSingleSelectRowResultV1SingleSelectResultsError
    );
    const totalResponses = getInt32(dto, "totalResponses", InvalidGridSingleSelectRowResultV1TotalResponsesError);
    return new GridSingleSelectRowResultV1(
      gridOptionV1,
      singleSelectResults,
      totalResponses
    );
  }

  toDTO(): GridSingleSelectRowResultV1DTO {
    const dto: GridSingleSelectRowResultV1DTO = {
        gridOptionV1: this.gridOptionV1.toDTO(),
        singleSelectResults: this.singleSelectResults.map((e: GridSingleSelectResultV1) => { return e.toDTO() }),
        totalResponses: this.totalResponses
    };
    return dto;
  }
  private static validateSingleSelectResults = (singleSelectResults: GridSingleSelectResultV1[]): void => {
    if(singleSelectResults.length > 32) {
      throw new InvalidGridSingleSelectRowResultV1SingleSelectResultsMaxSizeError(
        32,
        `Attribute singleSelectResults is too long. Size is ${singleSelectResults.length}. Max size is 32.`
      );
    }
  }
  
}

GridSingleSelectRowResultV1.prototype.toString = function toString(): string {
  return `GridSingleSelectRowResultV1(gridOptionV1='${this.gridOptionV1}',singleSelectResults='${this.singleSelectResults}',totalResponses='${this.totalResponses}')`;
};

export class InvalidGridSingleSelectRowResultV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleSelectRowResultV1Error";
  }
}
export class InvalidGridSingleSelectRowResultV1GridOptionV1Error extends InvalidGridSingleSelectRowResultV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleSelectRowResultV1GridOptionV1Error";
  }
}

export class InvalidGridSingleSelectRowResultV1SingleSelectResultsError extends InvalidGridSingleSelectRowResultV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleSelectRowResultV1SingleSelectResultsError";
  }
}

export class InvalidGridSingleSelectRowResultV1SingleSelectResultsMaxSizeError extends InvalidGridSingleSelectRowResultV1SingleSelectResultsError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleSelectRowResultV1SingleSelectResultsMaxSizeError";
  }
}

export class InvalidGridSingleSelectRowResultV1TotalResponsesError extends InvalidGridSingleSelectRowResultV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridSingleSelectRowResultV1TotalResponsesError";
  }
}
